export const FILTER_CONFIG = {
  charging: {
    mapFilter: ["==", ["get", "isPurposeCharging"], true],
    tagName: "用途:充電",
    infoText: "スマホの充電に適したお店を表示しています"
  },
  nomad: {
    mapFilter: ["==", ["get", "isPurposeNomad"], true],
    tagName: "用途:ノマド",
    infoText: "パソコン作業に適したお店を表示しています"
  }
};

const DEFAULT_CENTER = { lat: 35.68129, lng: 139.76624 };

export function resolveInitialViewport(search) {
  const params = new URLSearchParams(search || "");
  const ll = (params.get("ll") || "").split(",").map((value) => Number.parseFloat(value.trim()));
  const lat = Number.isFinite(ll[0]) ? ll[0] : DEFAULT_CENTER.lat;
  const lng = Number.isFinite(ll[1]) ? ll[1] : DEFAULT_CENTER.lng;
  const zoomValue = Number.parseFloat(params.get("z"));
  const zoom = Number.isFinite(zoomValue) ? zoomValue : 15;

  return { lat, lng, zoom };
}

export function createMapInstance({ mapboxgl, containerId, search }) {
  const viewport = resolveInitialViewport(search);

  return new mapboxgl.Map({
    container: containerId,
    style: "mapbox://styles/mapbox/standard",
    center: [viewport.lng, viewport.lat],
    zoom: viewport.zoom,
    attributionControl: false,
    language: "ja",
    config: {
      basemap: {
        show3dObjects: false
      }
    }
  });
}

export function syncUrlWithMapState(map, urlString) {
  const currentCenter = map.getCenter();
  const currentZoom = map.getZoom();
  const nextUrl = new URL(urlString);

  nextUrl.searchParams.set("ll", `${currentCenter.lat.toFixed(6)},${currentCenter.lng.toFixed(6)}`);
  nextUrl.searchParams.set("z", currentZoom.toFixed(2).replace(/\.00$/, ""));

  return nextUrl;
}

export function createModeController({ map, infoTextElement, onModeChanged }) {
  let currentMode = "charging";

  const applyMode = (mode) => {
    const config = FILTER_CONFIG[mode];
    if (!config) return;

    currentMode = mode;
    if (infoTextElement) infoTextElement.textContent = config.infoText;

    if (map.getLayer("spots-symbol")) {
      map.setFilter("spots-symbol", config.mapFilter);
    }

    onModeChanged?.(mode);
  };

  return {
    applyMode,
    getCurrentMode: () => currentMode
  };
}